import {
  Col,
  Descriptions,
  Divider,
  QRCode,
  Row,
  Table,
  Typography,
} from "antd";
import { HeaderPrintForm, InfoItem, Sign } from "components/common/PrintForm";
import Notification from "components/common/notification/notification";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { getListDoiTuongAPI } from "redux/reducer/common";
import { medicalExaminationService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  checkEmptyObj,
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  formatDateToString,
  formatToCurrencyType,
  convertDateStringToDateTimezone_7,
  toArray,
} from "helper/common";
import { FORMAT_TIME } from "types/enums";
import ContentPrint from "pages/Refractive/InforDetails/PrintForm/ContentPrint";
import DetailExam from "../DetailExam/DetailExam";
import { columns } from "../config";
import "./Content.scss";
import VisualAcuityPrint from "pages/Refractive/InforDetails/PrintForm/VisualAcuity/VisualAcuity";
import GlassesPrescriptionPrint from "pages/Refractive/InforDetails/PrintForm/GlassesPrescription/GlassesPrescription";
import NurseExamPrintOut from "../DetailExam/NurseExam/NurseExamPrint copy";
import DryAutoRefractionPrint from "pages/Refractive/InforDetails/PrintForm/DryAutoRefraction/DryAutoRefraction";
import Pgp1Print from "pages/Refractive/InforDetails/PrintForm/pgp/pgp1/pgp1";
import Pgp2Print from "pages/Refractive/InforDetails/PrintForm/pgp/pgp2/pgp2";
import Pgp3Print from "pages/Refractive/InforDetails/PrintForm/pgp/pgp3/pgp3";
import SpectaclesConditionPrint from "pages/Refractive/InforDetails/PrintForm/SpectaclesCondition/SpectaclesCondition";
import NearPgpPrint from "pages/Refractive/InforDetails/PrintForm/NearPgp/NearPgp";
import DryNetRetinoscopyPrint from "pages/Refractive/InforDetails/PrintForm/DryNetRetinoCopy/DryNetRetinoCopy";
import DryRefractionPrint from "pages/Refractive/InforDetails/PrintForm/DryRefraction/DryRefraction";
import DilatedAutoRefractionPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient/DilatedAutoRefraction/DilatedAutoRefraction";
import DilatedNetRetinoscopyPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient/DilatedNetRetinoscopy/DilatedNetRetinoscopy";
import DilatedRefractionPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient/DilatedRefraction/DilatedRefraction";
import PmtAutoRefractionPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient copy/PmtAutoRefraction/pmtAutoRefraction";
import PmtNetRetinoscopyPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient copy/PmtNetRetinoscopy/PmtNetRetinoscopy";
import PmtRefractionDtosPrint from "pages/Refractive/InforDetails/PrintForm/DilatePatient copy/PmtRefraction/PmtRefraction";
import { listOptionMat } from "pages/Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/ConcludeIcd.config";

const Content = forwardRef((props, ref) => {
  const dispatch = useAppDispatch();
  const listDoiTuongKCB = useAppSelector(
    (state) => state.common.listDoiTuongKCB
  );
  const idPhieu = useAppSelector((state) => state.examination.idReceipt);
  const [detailPhieu, setDetailPhieu] = useState<any>();
  const [detailExam, setDetailExam] = useState<any>(null);
  const [detailPhieuRefraction, setDetailPhieuRefraction] = useState<any>();
  const detailsReceiptRefraction = useAppSelector((e) => e.pending.data);

  const [nurseInfo, setNurseInfo] = useState<any>(null);
  const printRef = useRef<any>();
  const [printExam, setPrintExam] = useState<boolean>(true);
  const [treatment, setTreatment] = useState<boolean>(true);
  const [diagnose, setDiagnose] = useState<boolean>(true);
  const [benhphu, setBenhphu] = useState<boolean>(true);
  const [donthuoc, setDonthuoc] = useState<boolean>(true);
  const [ketluan, setKetluan] = useState<boolean>(true);
  const [henTaiKham, setHenTaiKham] = useState<boolean>(true);
  const [khucxa, setKhucxa] = useState<boolean>(true);
  const [khucxaDonKinh, setKhucxaDonKinh] = useState<boolean>(true);
  const [tienSuBenh, setTienSuBenh] = useState<boolean>(true);
  const [thongTinDieuDuong, setThongTinDieuDuong] = useState<boolean>(true);
  const [nhanAp, seNhanAp] = useState<boolean>(true);
  const [leDao, setLeDao] = useState<boolean>(true);
  const [duongHuyet, setDuongHuyet] = useState<boolean>(true);
  const [traThuoc, setTraThuoc] = useState<boolean>(true);
  const [allKhucXa, setAllKhucXa] = useState<boolean>(true);
  const [dsCDCDHA, setDsCDCDHA] = useState<boolean>(false);
  const [dsCDDienTim, setDsCDDienTim] = useState<boolean>(false);
  const [dsCDXetNghiem, setDsCDXetNghiem] = useState<boolean>(false);
  const [dsCDPTTT, setDsCDPTTT] = useState<boolean>(false);
  const [dsNCDXN, setDsNCDXN] = useState<any>([]);
  const [dsNCDCDHA, setDsNCDCDHA] = useState<any>([]);
  const [dsNCDDT, setDsNCDDT] = useState<any>([]);
  const [dsNCDPTTT, setDsNCDPTTT] = useState<any>([]);
  const [khucxaTuDong, setKhucXaTuDong] = useState<boolean>(true);
  const [pgp1, setPgp1] = useState<boolean>(true);
  const [pgp2, setPgp2] = useState<boolean>(true);
  const [pgp3, setPgp3] = useState<boolean>(true);
  const [nearPgp, setnearPgp] = useState<boolean>(true);
  const [spectacles, setSpectacles] = useState<boolean>(true);
  const [drynetNetRetinoscopy, setDrynetNetRetinoscopy] =
    useState<boolean>(true);
  const [drynetNetRefraction, setDrynetNetRefraction] = useState<boolean>(true);
  const [dryRefraction, setDryRefraction] = useState<boolean>(true);
  const [dilatedAutoRefraction, setDilatedAutoRefraction] =
    useState<boolean>(true);
  const [dilatedNetRetinoscopy, setDilatedNetRetinoscopy] =
    useState<boolean>(true);
  const [dilatedRefraction, setDilatedRefraction] = useState<boolean>(true);
  const [pmtAutoRefraction, setPmtAutoRefraction] = useState<boolean>(true);
  const [pmtNetRetinoscopy, setPmtNetRetinoscopy] = useState<boolean>(true);
  const [pmtRefraction, setPmtRefraction] = useState<boolean>(true);
  const [display, setDisplay] = useState<boolean>(false);
  const [ngayHenTaiKham, setNgayHenTaiKham] = useState<boolean>(true);

  useImperativeHandle(ref, () => ({
    getContent: () => {
      // setDisplay(true)
      let tmp = printRef.current;
      // setDisplay(false);

      return tmp;
    },
    setPrintExam: setPrintExam,
    setTreatment: setTreatment,
    setDiagnose: setDiagnose,
    setBenhphu: setBenhphu,
    setDonthuoc: setDonthuoc,
    setKetluan: setKetluan,
    setHenTaiKham: setHenTaiKham,
    setKhucxa: setKhucxa,
    setKhucxaDonKinh: setKhucxaDonKinh,
    setTienSuBenh: setTienSuBenh,
    setThongTinDieuDuong: setThongTinDieuDuong,
    seNhanAp: seNhanAp,
    setLeDao: setLeDao,
    setDuongHuyet: setDuongHuyet,
    setTraThuoc: setTraThuoc,
    setDsCDCDHA: setDsCDCDHA,
    setDsCDXetNghiem: setDsCDXetNghiem,
    setDsCDDienTim: setDsCDDienTim,
    setDsCDPTTT: setDsCDPTTT,
    setDsNCDXN: setDsNCDXN,
    setDsNCDCDHA: setDsNCDCDHA,
    setDsNCDDT: setDsNCDDT,
    setDsNCDPTTT: setDsNCDPTTT,
    setAllKhucXa: setAllKhucXa,
    setKhucXaTuDong: setKhucXaTuDong,
    setPgp1: setPgp1,
    setPgp2: setPgp2,
    setPgp3: setPgp3,
    setnearPgp: setnearPgp,
    setSpectacles: setSpectacles,
    setDrynetNetRetinoscopy: setDrynetNetRetinoscopy,
    setDrynetNetRefraction: setDrynetNetRefraction,
    setDryRefraction: setDryRefraction,
    setDilatedAutoRefraction: setDilatedAutoRefraction,
    setDilatedNetRetinoscopy: setDilatedNetRetinoscopy,
    setDilatedRefraction: setDilatedRefraction,
    setPmtAutoRefraction: setPmtAutoRefraction,
    setPmtNetRetinoscopy: setPmtNetRetinoscopy,
    setPmtRefraction: setPmtRefraction,
    setNgayHenTaiKham: setNgayHenTaiKham,
  }));

  useEffect(() => {
    dispatch(getListDoiTuongAPI());
  }, []);
  const getDetailPhieu = async (idPhieu) => {
    try {
      const res = await medicalExaminationService.getPKNTAllById({
        id: idPhieu,
      });
      setDetailPhieuRefraction(res.refractionDto);
      setDetailPhieu(res);
      // dispatch(setData(res.))
    } catch (error) {
      Notification("error", "Lỗi khi lấy thông tin phiếu khám!");
    }
  };

  useEffect(() => {
    setDetailPhieu({
      ...detailPhieu,
      refractionDto: detailsReceiptRefraction,
    });
  }, [detailsReceiptRefraction]);

  useEffect(() => {
    if (detailPhieu?.jsonDieuDuongDto) {
      parseJsonValueToObject(detailPhieu?.jsonDieuDuongDto);
    }
    if (detailPhieu?.chuanDoanDto?.jsonValue) {
      const parseObject = JSON.parse(detailPhieu?.chuanDoanDto?.jsonValue);
      setDetailExam(parseObject);
    }
  }, [detailPhieu]);
  useEffect(() => {
    if (detailExam) {
    }
  }, [detailExam]);
  const parseJsonValueToObject = (dataJson) => {
    const vitalSign = JSON.parse(dataJson?.vitalSigns);

    setNurseInfo(vitalSign);
  };
  useEffect(() => {
    if (idPhieu != null) {
      getDetailPhieu(idPhieu);
      // getNurseValue(idPhieu);
    }
  }, [idPhieu]);
  const fields1 = [
    {
      label: "Họ và tên",
      value: detailPhieu?.hoTen?.toString()?.toUpperCase(),
    },
    {
      label: "Ngày sinh",
      value: `${
        detailPhieu?.ngaySinh
          ? convertDateStringToDateTimezone_7(detailPhieu?.ngaySinh).format(
              FORMAT_TIME.dayFull
            )
          : ""
      }`,
    },
    { label: "Giới tính", value: detailPhieu?.gioiTinh == 0 ? "Nam" : "Nữ" },
    // { label: "Điện thoại", value: detailPhieu?.dienThoai },
    // {label: "Địa chỉ", value: detailPhieu?.diaChiTongHop},
  ];
  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(detailPhieu?.thoiGianKham, FORMAT_TIME.dayFull),
    },
    { label: "Mã bệnh nhân", value: detailPhieu?.maBenhNhan },
    { label: "Mã phiếu khám", value: detailPhieu?.idPhieuKham },

    // { label: "Lý do khám", value: detailPhieu?.lyDoKham },
  ];
  useEffect(() => {}, [printExam, display]);
  return (
    <div
      className="print-form-exam-out"
      style={!display ? { display: "none", overflow: "scroll" } : {}}
    >
      <div ref={printRef} className="form-exam-out">
        <table className="form-exam-out-content">
          <thead className="table-header">
            <tr style={{ height: "10px" }}></tr>
            <HeaderPrintForm></HeaderPrintForm>
            <tr style={{ height: "30px" }}></tr>
          </thead>
          <tbody>
            <div>
              <InfoItem
                fields1={fields1}
                fields2={fields2}
                idBenhNhan={detailPhieu?.idBenhNhan}
                title={"KẾT QUẢ KHÁM BỆNH NGOẠI TRÚ"}
                isChiefComplant={true}
                chiefComplaints={detailPhieu?.lyDoKham}
                address={detailPhieu?.diaChiTongHop}
                bold={"bold"}
              />
              {khucxa && detailPhieu?.refractionDto && (
                <div className="container2" style={{ marginBottom: 8 }}>
                  <Row align={"middle"} gutter={4}>
                    <Col>
                      <Typography.Text
                        style={{
                          fontWeight: "700",
                          fontSize: 24,

                          marginBottom: 8,
                        }}
                      >
                        Khúc xạ
                      </Typography.Text>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12} style={{ padding: "0 4px" }}>
                      <Row
                        style={{
                          padding: "5px 0",
                          backgroundColor: "#f0f0f0",
                          fontWeight: "600",
                        }}
                        justify={"center"}
                      >
                        Mắt phải
                      </Row>
                    </Col>
                    <Col span={12} style={{ paddingRight: "4px" }}>
                      <Row
                        style={{
                          padding: "5px 0",
                          backgroundColor: "#f0f0f0",
                          fontWeight: "600",
                        }}
                        justify={"center"}
                      >
                        Mắt trái
                      </Row>
                    </Col>
                  </Row>
                </div>
              )}
              {khucxaTuDong &&
                (detailPhieu?.refractionDto?.dryAutoRefractionDtos?.left ||
                  detailPhieu?.refractionDto?.dryAutoRefractionDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DryAutoRefractionPrint
                      data={detailPhieu?.refractionDto.dryAutoRefractionDtos}
                    />
                  </Row>
                )}
              {khucxa &&
                (detailPhieu?.refractionDto?.visualAcuityDtos?.left ||
                  detailPhieu?.refractionDto?.visualAcuityDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <VisualAcuityPrint
                      detail={detailPhieu?.refractionDto}
                      type={0}
                    />
                  </Row>
                )}
              {pgp1 &&
                (detailPhieu?.refractionDto?.pgp1?.left ||
                  detailPhieu?.refractionDto?.pgp1?.right) && (
                  <Row align={"top"} gutter={4}>
                    <Pgp1Print data={detailPhieu?.refractionDto.pgp1} />
                  </Row>
                )}
              {pgp2 &&
                (detailPhieu?.refractionDto?.pgp2?.left ||
                  detailPhieu?.refractionDto?.pgp2?.right) && (
                  <Row align={"top"} gutter={4}>
                    <Pgp2Print data={detailPhieu?.refractionDto.pgp2} />
                  </Row>
                )}
              {pgp3 &&
                (detailPhieu?.refractionDto?.pgp3?.left ||
                  detailPhieu?.refractionDto?.pgp3?.right) && (
                  <Row align={"top"} gutter={4}>
                    <Pgp3Print data={detailPhieu?.refractionDto.pgp3} />
                  </Row>
                )}
              {nearPgp &&
                (detailPhieu?.refractionDto?.nearPGPDto?.left ||
                  detailPhieu?.refractionDto?.nearPGPDto?.right) && (
                  <Row align={"top"} gutter={4}>
                    <NearPgpPrint
                      data={detailPhieu?.refractionDto.nearPGPDto}
                    />
                  </Row>
                )}
              {spectacles &&
                (detailPhieu?.refractionDto?.pgp3?.left ||
                  detailPhieu?.refractionDto?.pgp3?.right) && (
                  <Row align={"top"} gutter={4}>
                    <SpectaclesConditionPrint
                      data={detailPhieu?.refractionDto.spectaclesConditionDto}
                    />
                  </Row>
                )}
              {drynetNetRetinoscopy &&
                (detailPhieu?.refractionDto?.drynetNetRetinoscopy?.left ||
                  detailPhieu?.refractionDto?.drynetNetRetinoscopy?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DryNetRetinoscopyPrint
                      data={detailPhieu?.refractionDto?.drynetNetRetinoscopy}
                    />
                  </Row>
                )}
              {dryRefraction &&
                (detailPhieu?.refractionDto?.dryRefraction?.left ||
                  detailPhieu?.refractionDto?.dryRefraction?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DryRefractionPrint
                      data={detailPhieu?.refractionDto?.dryRefraction}
                    />
                  </Row>
                )}
              {dilatedAutoRefraction &&
                (detailPhieu?.refractionDto?.dilatedAutoRefractionDtos?.left ||
                  detailPhieu?.refractionDto?.dilatedAutoRefractionDtos
                    ?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DilatedAutoRefractionPrint
                      data={
                        detailPhieu?.refractionDto?.dilatedAutoRefractionDtos
                      }
                    />
                  </Row>
                )}
              {dilatedNetRetinoscopy &&
                (detailPhieu?.refractionDto?.dilatedNetRetinoscopyDtos?.left ||
                  detailPhieu?.refractionDto?.dilatedNetRetinoscopyDtos
                    ?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DilatedNetRetinoscopyPrint
                      data={
                        detailPhieu?.refractionDto?.dilatedNetRetinoscopyDtos
                      }
                    />
                  </Row>
                )}
              {dilatedRefraction &&
                (detailPhieu?.refractionDto?.dilatedRefractionDtos?.left ||
                  detailPhieu?.refractionDto?.dilatedRefractionDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <DilatedRefractionPrint
                      data={detailPhieu?.refractionDto?.dilatedRefractionDtos}
                    />
                  </Row>
                )}
              {pmtAutoRefraction &&
                (detailPhieu?.refractionDto?.pmtAutoRefractionDtos?.left ||
                  detailPhieu?.refractionDto?.pmtAutoRefractionDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <PmtAutoRefractionPrint
                      data={detailPhieu?.refractionDto?.pmtAutoRefractionDtos}
                    />
                  </Row>
                )}
              {pmtNetRetinoscopy &&
                (detailPhieu?.refractionDto?.pmtNetRetinoscopyDtos?.left ||
                  detailPhieu?.refractionDto?.pmtNetRetinoscopyDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <PmtNetRetinoscopyPrint
                      data={detailPhieu?.refractionDto?.pmtNetRetinoscopyDtos}
                    />
                  </Row>
                )}
              {pmtRefraction &&
                (detailPhieu?.refractionDto?.pmtRefractionDtos?.left ||
                  detailPhieu?.refractionDto?.pmtRefractionDtos?.right) && (
                  <Row align={"top"} gutter={4}>
                    <PmtRefractionDtosPrint
                      data={detailPhieu?.refractionDto?.pmtRefractionDtos}
                    />
                  </Row>
                )}
              {khucxaDonKinh &&
                (detailPhieu?.refractionDto?.glassesPrescriptionDto?.left ||
                  detailPhieu?.refractionDto?.glassesPrescriptionDto
                    ?.right) && (
                  <div
                    className="container2"
                    style={{ marginBottom: 8, width: "100%" }}
                  >
                    <GlassesPrescriptionPrint
                      detailPhieu={
                        detailPhieu?.refractionDto?.glassesPrescriptionDto
                      }
                    />
                  </div>
                )}
              {detailPhieu?.refractionDto && <Divider />}
              {treatment && nurseInfo && (
                <div className="container2" style={{ marginBottom: 8 }}>
                  {/* <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 20,

                        marginBottom: 8,
                      }}
                    >
                      Điều dưỡng
                    </Typography.Text>
                  </Row> */}
                  <Row gutter={[8, 8]}>
                    <NurseExamPrintOut
                      tienSuBenh={tienSuBenh}
                      jsonData={detailPhieu?.jsonDieuDuongDto}
                      leDao={leDao}
                      nhanAp={nhanAp}
                      thongTinDieuDuong={thongTinDieuDuong}
                      traThuoc={traThuoc}
                      duongHuyet={duongHuyet}
                    />
                    <Divider />
                  </Row>
                </div>
              )}

              {/* Khám bênh */}
              {printExam && !checkEmptyObj(detailExam) && (
                <div className="container2" style={{ marginBottom: 8 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 8,
                      }}
                    >
                      Khám bệnh
                    </Typography.Text>
                  </Row>
                  <Row gutter={[8, 8]}>
                    <DetailExam data={detailExam}></DetailExam>
                  </Row>
                  <Divider />
                </div>
              )}

              {diagnose &&
                detailPhieu?.ketLuanDto?.chiTietKetLuans.length > 0 && (
                  <div className="container2" style={{ marginBottom: 8 }}>
                    <Row>
                      <Typography.Text
                        style={{
                          fontWeight: "700",
                          fontSize: 24,

                          marginBottom: 8,
                        }}
                      >
                        Chẩn đoán (ICD)
                      </Typography.Text>
                    </Row>
                    <>
                      {detailPhieu?.ketLuanDto?.chiTietKetLuans?.map((e) => {
                        return (
                          <div>
                            {`${
                              e?.mat || e?.mat == 0
                                ? `${
                                    listOptionMat?.find(
                                      (mat) => mat?.value == e?.mat
                                    )?.label
                                  }:`
                                : ""
                            } ${e?.maIcd} - ${e?.tenIcd} ${
                              e?.ghiChu ? `- ${e?.ghiChu}` : ""
                            } `}
                          </div>
                        );
                      })}
                    </>
                    <Divider />
                  </div>
                )}

              {benhphu &&
                detailPhieu?.ketLuanDto?.chiTietBenhPhuDtos.length > 0 && (
                  <div className="container2" style={{ marginBottom: 8 }}>
                    <Row>
                      <Typography.Text
                        style={{
                          fontWeight: "700",
                          fontSize: 24,

                          marginBottom: 8,
                        }}
                      >
                        Bệnh phụ
                      </Typography.Text>
                    </Row>
                    <>
                      {detailPhieu?.ketLuanDto?.chiTietBenhPhuDtos?.map((e) => {
                        return (
                          <div>{`${e?.maIcd} - ${e?.tenIcd} ${
                            e?.ghiChu ? `- ${e?.ghiChu}` : ""
                          }`}</div>
                        );
                      })}
                    </>
                    <Divider />
                  </div>
                )}

              {ketluan && detailPhieu?.ketLuanDto?.ketLuanBacSy && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                        marginTop: 12,
                      }}
                    >
                      Chẩn đoán khác
                    </Typography.Text>
                  </Row>

                  <>{detailPhieu?.ketLuanDto?.ketLuanBacSy}</>
                  <Divider />
                </div>
              )}

              {(detailPhieu?.donThuocDto?.thuocs.length > 0 ||
                detailPhieu?.donThuocPhuDto?.thuocs.length > 0) && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                      }}
                    >
                      Đơn thuốc
                    </Typography.Text>
                  </Row>

                  <Table
                    className="table-print"
                    columns={columns}
                    dataSource={[
                      ...toArray(detailPhieu?.donThuocDto?.thuocs),
                      ...toArray(detailPhieu?.donThuocPhuDto?.thuocs),
                    ].sort((a, b) => a?.thuTu - b?.thuTu)}
                    pagination={false}
                    bordered
                  ></Table>
                  <Divider />
                </div>
              )}
              {henTaiKham && detailPhieu?.ketLuanDto?.taiKham && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                      }}
                    >
                      Ghi chú
                    </Typography.Text>
                  </Row>

                  <>{detailPhieu?.ketLuanDto?.taiKham}</>
                  <Divider />
                </div>
              )}
              {ngayHenTaiKham && detailPhieu?.ketLuanDto?.ngayHenTaiKham && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                      }}
                    >
                      Ngày hẹn tái khám
                    </Typography.Text>
                  </Row>
                  <Typography.Text>
                    {convertIosStringToDate(
                      detailPhieu?.ketLuanDto?.ngayHenTaiKham
                    )?.format("DD/MM/YYYY")}
                  </Typography.Text>
                  <Divider />
                </div>
              )}

              {dsCDCDHA && dsNCDCDHA.length > 0 && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                        marginTop: 12,
                      }}
                    >
                      Danh sách chỉ định CĐHA
                    </Typography.Text>
                  </Row>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "50%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        {/* <th style={{width: "14%"}}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th> */}
                      </tr>
                      {dsNCDCDHA?.map((it) => {
                        return (
                          <>
                            {it.chiDinhDtos.map((dt, idx) => {
                              return (
                                <tr>
                                  <td className="ta-c">
                                    <Typography.Text>
                                      {it.index + idx + 1}
                                    </Typography.Text>
                                  </td>
                                  <td>
                                    <Typography.Text>
                                      {dt.tenChiDinh}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {dt.soLuong}
                                    </Typography.Text>
                                  </td>
                                  {/* <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.donGia)}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.thanhTien)}
                                    </Typography.Text>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </>
                        );
                      })}
                    </table>
                  </div>
                  <Divider />
                </div>
              )}

              {dsCDXetNghiem && dsNCDXN.length > 0 && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                        marginTop: 12,
                      }}
                    >
                      Danh sách chỉ định Xét nghiệm
                    </Typography.Text>
                  </Row>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "50%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        {/* <th style={{width: "14%"}}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th> */}
                      </tr>
                      {dsNCDXN?.map((it) => {
                        return (
                          <>
                            <tr>
                              <td colSpan={5}>
                                <Typography.Text strong>
                                  {it.tenNhomChiDinh}
                                </Typography.Text>
                              </td>
                            </tr>
                            {it.chiDinhDtos.map((dt, idx) => {
                              return (
                                <tr>
                                  <td className="ta-c">
                                    <Typography.Text>
                                      {it.index + idx + 1}
                                    </Typography.Text>
                                  </td>
                                  <td>
                                    <Typography.Text>
                                      {dt.tenChiDinh}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {dt.soLuong}
                                    </Typography.Text>
                                  </td>
                                  {/* <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.donGia)}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.thanhTien)}
                                    </Typography.Text>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </>
                        );
                      })}
                    </table>
                  </div>
                  <Divider />
                </div>
              )}

              {dsCDDienTim && dsNCDDT.length > 0 && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                        marginTop: 12,
                      }}
                    >
                      Danh sách chỉ định Điện tim
                    </Typography.Text>
                  </Row>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "50%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        {/* <th style={{width: "14%"}}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th> */}
                      </tr>
                      {dsNCDDT?.map((it) => {
                        return (
                          <>
                            {it.chiDinhDtos.map((dt, idx) => {
                              return (
                                <tr>
                                  <td className="ta-c">
                                    <Typography.Text>
                                      {it.index + idx + 1}
                                    </Typography.Text>
                                  </td>
                                  <td>
                                    <Typography.Text>
                                      {dt.tenChiDinh}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {dt.soLuong}
                                    </Typography.Text>
                                  </td>
                                  {/* <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.donGia)}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.thanhTien)}
                                    </Typography.Text>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </>
                        );
                      })}
                    </table>
                  </div>
                  <Divider />
                </div>
              )}

              {dsCDPTTT && dsNCDPTTT.length > 0 && (
                <div className="container2" style={{ marginBottom: 12 }}>
                  <Row>
                    <Typography.Text
                      style={{
                        fontWeight: "700",
                        fontSize: 24,

                        marginBottom: 12,
                        marginTop: 12,
                      }}
                    >
                      Danh sách chỉ định PT/TT
                    </Typography.Text>
                  </Row>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "50%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        {/* <th style={{width: "14%"}}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{width: "14%"}}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th> */}
                      </tr>
                      {dsNCDPTTT?.map((it) => {
                        return (
                          <>
                            {it.chiDinhDtos.map((dt, idx) => {
                              return (
                                <tr>
                                  <td className="ta-c">
                                    <Typography.Text>
                                      {it.index + idx + 1}
                                    </Typography.Text>
                                  </td>
                                  <td>
                                    <Typography.Text>
                                      {dt.tenChiDinh}
                                    </Typography.Text>
                                  </td>
                                  <td
                                    className="ta-r"
                                    style={{ textAlign: "center" }}
                                  >
                                    <Typography.Text>
                                      {dt.soLuong}
                                    </Typography.Text>
                                  </td>
                                  {/* <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.donGia)}
                                    </Typography.Text>
                                  </td>
                                  <td className="ta-r">
                                    <Typography.Text>
                                      {formatToCurrencyType(dt.thanhTien)}
                                    </Typography.Text>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </>
                        );
                      })}
                    </table>
                  </div>
                  <Divider />
                </div>
              )}

              <Sign
                label="Bác sĩ kết luận"
                nguoiThucHien={detailPhieu?.bacSyKham ?? " "}
                time={detailPhieu?.thoiGianKham}
              ></Sign>
            </div>
          </tbody>
          <tfoot className="table-footer" style={{ height: "20mm" }}></tfoot>
        </table>
      </div>
    </div>
  );
});

export default Content;
